import { defineMessages } from "react-intl";

const messages = defineMessages({
    h2: {
        id: "aboutus.contributors.h2",
    },
    translators: {
        id: "aboutus.contributors.translators",
    },
    moderators: {
        id: "aboutus.contributors.moderators",
    },
    partners: {
        id: "aboutus.contributors.partners",
    },
    additionalGraphics: {
        id: "aboutus.contributors.additionalGraphics",
    },
    singers: {
        id: "aboutus.contributors.singers",
    },
});

export default messages;
